module.exports = __webpack_public_path__ + "static/media/outlet_role_assignment.13d322cb.svg";